// Add this to your slideshow-component.js or create a new file
(function() {
  class SlideshowClickable {
    constructor(component) {
      this.component = component;
      this.slides = component.querySelectorAll('.swiper-slide');
      this.init();
    }

    init() {
      this.slides.forEach((slide) => {
        const slideLink = slide.dataset.slideLink;
        if (slideLink) {
          // Make the slide clickable
          slide.style.cursor = 'pointer';
          
          // Handle click on the slide background, but not on buttons
          slide.addEventListener('click', (e) => {
            // Don't navigate if clicking on buttons or links inside the slide content
            if (e.target.closest('a, button, [role="button"]')) {
              return;
            }
            window.location.href = slideLink;
          });
          
          // Add keyboard accessibility
          slide.setAttribute('tabindex', '0');
          slide.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (!e.target.closest('a, button, [role="button"]')) {
                window.location.href = slideLink;
              }
            }
          });
        }
      });
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('slideshow-component').forEach((component) => {
      new SlideshowClickable(component);
    });
  });

  // Also handle dynamic slideshow initialization
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const slideshow = event.target.querySelector('slideshow-component');
      if (slideshow) {
        new SlideshowClickable(slideshow);
      }
    });
  }
})();